import { render, staticRenderFns } from "./agregaProc.vue?vue&type=template&id=b5b55028&"
import script from "./agregaProc.vue?vue&type=script&lang=js&"
export * from "./agregaProc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports